import { Link } from 'react-router-dom';
import './Breadcrumbs.css';

const SITE_URL = 'https://baatcheetapp.in';

// items: [{ name: 'Home', path: '/' }, { name: 'Safety', path: '/safety' }]
// Last item renders as the current page (no link). Returns both the visible
// nav and the matching BreadcrumbList schema so the two never drift apart —
// pass schema straight into <Seo jsonLd={[..., breadcrumbSchema]} />.
export function buildBreadcrumbSchema(items) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: item.name,
      item: `${SITE_URL}${item.path}`,
    })),
  };
}

export default function Breadcrumbs({ items }) {
  return (
    <nav className="breadcrumbs shell" aria-label="Breadcrumb">
      <ol>
        {items.map((item, i) => {
          const isLast = i === items.length - 1;
          return (
            <li key={item.path}>
              {isLast ? (
                <span aria-current="page">{item.name}</span>
              ) : (
                <>
                  <Link to={item.path}>{item.name}</Link>
                  <span className="bc-sep" aria-hidden="true">/</span>
                </>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
